import { Yup } from 'cng-web-lib'

function makeValidationSchema() {
  return Yup.object({
    vesselName: Yup.string()
      .required('Vessel Name is required')
      .max(70, 'Max 70 characters'),
    imoNumber: Yup.string()
      .required('IMO Number is required')
      .matches(/^\d{7}$/, 'IMO must be exactly 7 digits'),
    carrierIdentifier: Yup.string()
      .required('Carrier Identifier is required')
      .max(3, 'Max 3 characters'),
    vesselFlagCountry: Yup.string().nullable()
      .matches(/^$|^[A-Z]{2}$/, 'Must be a valid 2-character country code'),
    vesselOwnershipIndicatorCode: Yup.string().nullable(),
    vesselPowerTypeCode: Yup.string().nullable(),
    vesselPowerTypeDescription: Yup.string().nullable()
      .max(17, 'Max 17 characters')
  })
}

export default makeValidationSchema
